import React from 'react';
import Event from './Event.js';
import ModalForm from './Form/Form.js';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from 'react-select';
import ApiRequest from './ApiRequest';
import FileUploader from './FileUploader';
import ObjectAssign from 'object-assign';
import ReactDOM from "react-dom";
import ErrorBoundary from '../ErrorBoundary.js';
import EventFireLink from './EventFireLink';

export default class SingleMessageModal extends ModalForm {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            form: {
                recipient: 'candidate',
                subject: '',
                message: '',
                files: []
            },
            errors: {},
            errorMessage: null,
            successMessage: null,
            loading: false,
            user: null
        };
    }

    componentDidMount() {
        if (this.props.show) {
            this.setState({ show: true });
        }

        Event.on('singleMessageModal.show', (user) => {
            if (window.loggedInUser) {
                this.setState({ show: true, user, successMessage: null, errorMessage: null, errors: {} }, () => {
                    if (this.options().length === 1) {
                        let form = this.state.form;
                        form.recipient = 'candidate';
                        this.setState({ form });
                    }
                });
            } else {
                window.location.href = "/login";
            }
        }, this._rootNodeID);

        Event.on('modals.close', () => {
            this.setState({ show: false });
        }, this._rootNodeID);
    }

    componentWillUnmount() {
        Event.off('singleMessageModal.show', this._rootNodeID);
        Event.off('modals.close', this._rootNodeID);
    }

    options() {
        let contacts = [{ value: 'candidate', label: 'Candidate' }];
        if (this.state.user && this.state.user.mailAgentLink) {
            contacts.push({ value: 'agent', label: 'Agent' });
        }
        return contacts;
    }

    validSenderFields() {
        let errors = this.state.errors;
        let invalidFields = ['firstname', 'lastname', 'email', 'company', 'tel', 'address1', 'zip'].filter((fieldName) => {
            let invalid = !this.state.form[fieldName] || this.state.form[fieldName].length < 1;

            if (invalid) {
                errors[fieldName] = ['This field is required.'];
            } else {
                delete errors[fieldName];
            }

            return invalid;
        });

        if (invalidFields.length > 0) {
            this.setState({ errors });
            return false;
        } else {
            return true;
        }
    }

    sendMessage() {
        let form = {};
        ObjectAssign(form, this.state.form);
        form.content = form.message;
        form.to_uid = this.state.form.recipient === "agent" ? this.state.user.agency_uid : this.state.user.uid;
        if (form.files && form.files.length > 0) {
            form.includeFiles = true;
        }
        form.domain = this.state.user.siteUrl;

        this.setState({ loading: true, successMessage: null, errorMessage: null, errors: {} }, () => {
            let request = new ApiRequest();
            request.post('mail/send', form, (err, res) => {
                if (res && res.body && res.body.success) {
                    let form = this.state.form;
                    form.subject = '';
                    form.message = '';
                    form.files = [];
                    this.setState({
                        loading: false,
                        successMessage: 'Your message has been sent.',
                        form
                    });
                } else {
                    if (res && res.body) {
                        if (res.body.messages) {
                            this.setState({ loading: false, errors: res.body.messages });
                        } else {
                            if (res.body.errors && res.body.errors.errors) {
                                this.setState({ loading: false, errorMessage: res.body.errors.errors });
                            } else {
                                this.setState({
                                    loading: false,
                                    errorMessage: res.body && res.body.message ? res.body.message : 'There has been a problem sending your message.'
                                });
                            }
                        }
                    } else {
                        this.setState({
                            loading: false,
                            errorMessage: res && res.body && res.body.message ? res.body.message : 'There has been a problem sending your message.'
                        });
                    }
                }
            });
        });
    }

    handleUploadError(error) {
        let errors = this.state.errors;
        errors['files'] = [error];
        this.setState({ errors });
    }

    userOrCompanyName() {
        if (this.state.user.firstname && this.state.user.lastname) {
            return `${this.state.user.firstname} ${this.state.user.lastname}`;
        } else {
            return this.state.user.company ? this.state.user.company : '';
        }
    }

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={() => this.toggle()}>
                <ModalHeader toggle={() => this.toggle()}>
                    Email {this.state.user ? this.userOrCompanyName() : 'Candidate'}{this.state.form.recipient === 'agent' ? `'s agent` : ''}
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">

                            {this.showErrorMessage()}
                            {this.showSuccessMessage()}

                            {this.state.successMessage ? null : (
                                <form>
                                    {this.options().length > 1 ? (
                                        <div className={'form-group ' + this.getErrorClass('recipient')}>
                                            <Select
                                                name="recipient"
                                                placeholder="Select recipient(s)"
                                                resetValue={{ value: 'candidate' }}
                                                value={this.state.form.recipient}
                                                options={this.options()}
                                                onChange={(val) => this.handleChange('recipient', val.value)}
                                            />
                                            {this.showError('recipient')}
                                        </div>
                                    ) : null}

                                    <div className={'form-group ' + this.getErrorClass('subject')}>
                                        <input value={this.state.form.subject} onChange={(e) => this.handleChange('subject', e.target.value)} type="text" className="form-control" placeholder="Subject" />
                                        {this.showError('subject')}
                                    </div>
                                    <div className={'form-group ' + this.getErrorClass('content')}>
                                        <textarea value={this.state.form.message} onChange={(e) => this.handleChange('message', e.target.value)} className="form-control" rows="10" placeholder="Your message"></textarea>
                                        {this.showError('content')}
                                    </div>
                                    <div className={'form-group' + this.getErrorClass('files')}>
                                        <FileUploader files={this.state.files} onChange={(fileUrl) => this.handleChange('files', fileUrl)} onError={(error) => this.handleUploadError(error)} />
                                        {this.showError('files')}
                                    </div>
                                    <button type="button" onClick={() => this.sendMessage()} className="btn btn-primary btn-block mt-3">{this.state.loading ? (
                                        <i style={{
                                            width: '100%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            fontSize: '1rem'
                                        }} className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                                    ) : 'Send'}</button>
                                </form>
                            )}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }
}

let SingleMessageElement = document.getElementsByClassName('SingleMessageModal');
if (SingleMessageElement.length > 0) {
    ReactDOM.render(
        <ErrorBoundary>
            <SingleMessageModal />
        </ErrorBoundary>, SingleMessageElement[0]);
}

let EventFireLinkElements = document.getElementsByClassName('EventFireLink');

if (EventFireLinkElements.length > 0) {
    for (let key in EventFireLinkElements) {
        if (typeof EventFireLinkElements[key].getAttribute === 'function') {
            let eventName = EventFireLinkElements[key].getAttribute('data-eventName');
            let classNames = EventFireLinkElements[key].getAttribute('data-classNames');
            let title = EventFireLinkElements[key].getAttribute('data-title');
            let rawData = EventFireLinkElements[key].getAttribute('data-eventData');
            let imgUrl = EventFireLinkElements[key].getAttribute('data-imgUrl');
            let imgClasses = EventFireLinkElements[key].getAttribute('data-imgClasses');
            let data = null;
            if (rawData) {
                try {
                    data = JSON.parse(rawData);
                } catch (e) {
                    data = JSON.stringify(rawData);
                }
            }

            if (eventName && title || eventName && imgUrl) {
                ReactDOM.render(
                    <ErrorBoundary>
                        <EventFireLink eventName={eventName} title={title} classNames={classNames} data={data} imgUrl={imgUrl} imgClasses={imgClasses} />
                    </ErrorBoundary>, EventFireLinkElements[key]);
            }
        }
    }
}